// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

import {
    useQuery
} from '@tanstack/react-query';

import bksAPI from 'api/bks';
import crowdCountingAPI from '../api/crowd_counting';

import { useAuth0 } from "@auth0/auth0-react";

import { Chip, Grid, Tab, Tabs } from "@mui/material";
import moment from "moment";
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from "react";

import { Circle, ElectricBolt, PlayCircle, PsychologyAltSharp, PsychologySharp, ShowChart } from "@mui/icons-material";
import HeatMap from "nextus/Maps/HeatMap";

import CrowdCountingChart from "nextus/Charts/CrowdCountingChart";

import clearwaysAPI from "modules/clearways/api";
import Swal from "sweetalert2";
import process from "../api/process";
import compare from "../api/compare"
import CustomTabPanel from "../components/CustomTabPanel";
import GeneralTab from "../components/GeneralTab";
import LiveTab from "../components/LiveTab";
import Playback from "../components/Playback";
import TransportTab from "../components/TransportTab";
import InsightsTab from "./InsightsTab";

import "./MainView.css"
import PolarAreaChart from "./PolarAreaChart";
import { getUserAccessLevel } from "helper/user";
import StationDashboard from "./LineCounter/layouts/dashboard/StationDashboard";


var all_data_local = null;


function a11yProps(index, id_type) {
    return {
        id: `${id_type}-tab-${index}`,
        'aria-controls': `${id_type}-tabpanel-${index}`,
    };
}

function MainView({ event, device_uuids, startLimit, endLimit, settings, navigateToDevice, hasLive, selected_user }) {

    const { user } = useAuth0();
    bksAPI.loadToken(useAuth0());
    crowdCountingAPI.loadToken(useAuth0());
    clearwaysAPI.loadToken(useAuth0());

    var now = moment().unix();

    let endLimitWithNow;
    if (endLimit > now) {
        endLimitWithNow = now;
    }
    else {
        endLimitWithNow = endLimit;
    }

    const [endTime, setEndTime] = useState(endLimitWithNow); //6 hour
    const [startTime, setStartTime] = useState(startLimit);
    const [epoch, setEpoch] = useState(startLimit);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLive, setIsLive] = useState(false);
    const [interactingWithSlider, setInteractingWithSlider] = useState(false);
    const [mapTabValue, setMapTabValue] = useState(0);
    const [timeTabValue, setTimeTabValue] = useState(1);
    const [dashTabValue, setDashTabValue] = useState(0);
    const [hoveredDevices, setHoveredDevices] = useState([]);
    const [shownEpoch, setShownEpoch] = useState(null);
    const [playbackInterval, setPlaybackInterval] = useState(null);

    const group_size = ((endTime - startTime) / 30);

    const query = {
        start_time: startTime,
        end_time: endTime,
        group_size: group_size,
        uuids: device_uuids,
        bus_stop_ids: settings.buses ? ["2000252"] : [],
        tram_stop_ids: settings.trams ? ["2021101", "2021102", "202195"] : [],
        context_start_time: startLimit
    }



    var time = moment(epoch * 1000).tz("Australia/Sydney").format("HH:mm:ss");

    var lightPreset = 'day'

    const mapbox_settings = {
        style: "mapbox://styles/harrymontano/cmi3xx6nr00bh01r6etlugwf9",
        zoom: 14,
        // maxZoom: 22,
        minZoom: 1,
        lightPreset
    }


    const crowdCounting = useQuery({

        queryKey: ['crowdCounting', query.start_time, query.end_time, ...query.uuids, ...query.bus_stop_ids, ...query.tram_stop_ids],
        staleTime: Infinity,
        placeholderData: (prev) => prev,
        queryFn: async () => {
            // console.log("fetching")

            if (!isLive) {
                Swal.fire({
                    title: 'Loading...',
                    text: 'Downloading data',
                    allowOutsideClick: false, // Prevent closing during loading
                    showConfirmButton: false // Hide the confirm button
                });
                Swal.showLoading();
            }


            try {
                var data = await crowdCountingAPI.getAllData(query);
                // console.log(data);

                var all_data = {
                    timestamps: {},
                    graph: data.graph,
                    egress: data.egress,
                    descriptions: data.descriptions
                }

                // debugger;
                var increment_size = Math.ceil(data.metadata.heatmap_group_size);

                if (increment_size == 0) {
                    increment_size = 1;
                }
                for (var timestamp = data.metadata.start_time; timestamp <= data.metadata.end_time; timestamp += increment_size) {
                    all_data.timestamps[timestamp] = process(data, event, device_uuids, timestamp);
                }

                Swal.close()
                return all_data;


            }
            catch (e) {
                Swal.hideLoading(); // Hide the loader
                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'An error occurred during processing.'
                });
                console.error(e)
            }
        }
    });

    all_data_local = crowdCounting.data;

    // if(!selected_user.data){
    //     return "";
    // }


    const setEpochToSetValue = function (value) {

        if (all_data_local) {
            var steps = Object.keys(all_data_local.timestamps).map(Number);

            if (steps.length) {
                var closest_epoch = steps.reduce(function (prev, curr) {
                    return (Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev); //get closet number to epoch
                });

                if (closest_epoch != epoch) {
                    setEpoch(closest_epoch);
                }

            }


        }
    }

    function setStartTimeWithMod(new_time) {

        if (new_time < startLimit) {
            new_time = startLimit;
        }

        if (new_time > endLimitWithNow && new_time > moment.now()) {
            new_time = endLimitWithNow;
        }

        // debugger;

        setStartTime(new_time - (new_time % 10))
    }

    function setEndTimeWithMod(new_time) {

        if (new_time < startLimit) {
            new_time = startLimit;
        }

        if (new_time > endLimitWithNow && new_time > moment.now()) {
            new_time = endLimitWithNow;
        }



        setEndTime(new_time - (new_time % 10))
    }


    useEffect(() => {
        goToLive();

    }, [isLive])

    useEffect(() => {
        if (isPlaying) {
            setIsLive(false);
        }
    }, [isPlaying]);

    useEffect(() => {

        setIsLive(mapTabValue == 0 && hasLive); //live tab
    }, [mapTabValue])


    useEffect(() => {
        if (shownEpoch) {
            setEpoch(shownEpoch)
        }
    }, [shownEpoch])



    const steps = Object.keys(crowdCounting.data?.timestamps || {});

    var heatmap_data = {
        heatmap: [],
        gtfs: {
            trams: {
                departures: {
                    northbound: [],
                    southbound: []
                },
                vehicle_positions: []
            },
            buses: {
                vehicle_positions: [],
                departures: []
            }
        },
        camera_points: [],
        camera_polygons: [],
        egress: []

    };


    if (crowdCounting.data?.timestamps) {
        if (isLive && typeof crowdCounting.data.timestamps[epoch] == 'undefined') {
            var keys = Object.keys(crowdCounting.data.timestamps);
            // debugger;
            // heatmap_data = crowdCounting.data.timestamps[keys[keys.length - 1]];
            setEpochToSetValue(Number(keys[keys.length - 1]))
            heatmap_data = crowdCounting.data.timestamps[keys[keys.length - 1]];
        }
        else if (typeof crowdCounting.data.timestamps[epoch] == 'undefined') {
            setEpochToSetValue(epoch);
        }
        else {
            heatmap_data = crowdCounting.data.timestamps[epoch];

        }
    }

    function getNextEpochValue(timestamp) {
        // debugger;
        var steps = Object.keys(crowdCounting.data.timestamps).map(Number);
        var index = steps.indexOf(timestamp);
        if (index == -1 || index == steps.length - 1) {
            return false;
        }
        else {
            console.log(index)
            return steps[index + 1];
        }

    }

    function setEpochFromHeatmap(value) {
        // console.log(all_data_local)
        // console.log("setting epoch")
        setEpochToSetValue(value.unix())
    }

    function handleSliderMouseDown() {
        setInteractingWithSlider(true);
        setIsPlaying(false);
        // console.log("mouse down")
    }

    function handleSliderMouseUp() {
        setInteractingWithSlider(false)
        // console.log("mouse up")
    }

    function toggleIsPlaying() {
        // console.log(isPlaying)
        setIsPlaying(!isPlaying);
    }




    function valueLabelFormat(value) {
        return `${moment(value * 1000).format('hh:mmA, DD/MM/YYYY')}`;
    }

    function goToLive() {

        if (isLive) {
            // debugger;

            // var event_length = endLimit - startLimit;

            // var time_into_event = moment().unix() % event_length;

            // // time_into_event = time_into_event % (60 * 5);

            // var as_time = startLimit + time_into_event;

            setEpoch(moment().unix());
            setStartTimeWithMod(moment().subtract(5, 'minutes').unix());
            setEndTimeWithMod(moment().unix());
        }
    }

    if (playbackInterval == null) {

        useEffect(() => {
            // Show the component after a short delay (e.g., 100ms) to allow initial render
            const intervalId = setInterval(() => {
                // console.log(isPlaying)
                if (isPlaying) {
                    setEpoch(function (current_value) {

                        var next_value = getNextEpochValue(current_value);
                        // console.log(next_value)

                        if (!next_value) {
                            return startTime;
                        }
                        else {
                            return next_value;
                        }
                    });
                }

            }, 100);

            // Cleanup function to clear timeouts
            return () => {
                clearTimeout(intervalId);
            };
        }, [isPlaying]); // Empty dependency array means this runs once on mount

    }


    useEffect(() => {
        // Show the component after a short delay (e.g., 100ms) to allow initial render
        const intervalId = setInterval(() => {
            // console.log(isPlaying)
            if (isLive) {
                goToLive();
            }

        }, 10 * 1000);

        // Cleanup function to clear timeouts
        return () => {
            clearTimeout(intervalId);
        };
    }, [isLive]); // Empty dependency array means this runs once on mount

    function findMaxValueReduce(arr, property) {
        return arr.reduce((max, obj) => {
            return obj[property] > max ? obj[property] : max;
        }, -Infinity);
    }

    // debugger;

    // console.log(shownEpoch)

    // chart_data = JSON.parse(JSON.stringify(crowdCounting.data.graph));

    const chart = useMemo(
        () => {

            let chart_data = [];
            let maxY = 0;
            if (crowdCounting.data?.graph) {
                let all_data = [];
                chart_data = JSON.parse(JSON.stringify(crowdCounting.data.graph));
                var fields = ['count', 'max', 'mean', 'min'];
                var all_time_points = {};
                for (var row of chart_data) {
                    let key = row._id.time;
                    if (typeof all_time_points[key] == 'undefined') {
                        all_time_points[key] = {};
                        all_time_points[key].start = row.start;
                        for (var field of fields) {
                            all_time_points[key][field] = 0;
                        }
                    }
                    for (var field of fields) {
                        all_time_points[key][field] += row[field];
                    }
                }

                for (let _id in all_time_points) {
                    var ret = { _id, ...all_time_points[_id] };

                    all_data.push(ret);
                }

                maxY = findMaxValueReduce(all_data, 'max')

                if (hoveredDevices.length) {
                    chart_data = chart_data.filter(r => hoveredDevices.indexOf(r._id.uuid) >= 0).map(function (row) {
                        row._id = row._id.time;
                        return row;
                    });
                }
                else {
                    chart_data = all_data;
                }
            }

            return (<CrowdCountingChart chartData={chart_data} height={230} startLimit={startLimit} endLimit={endLimitWithNow} currentTime={epoch} setCurrentTime={setEpochFromHeatmap} startTime={startTime} setStartTime={setStartTimeWithMod} endTime={endTime} setEndTime={setEndTimeWithMod} event_data={[]} shownEpoch={shownEpoch} />)
        },
        [crowdCounting.data?.graph, endTime, startTime, shownEpoch]
    );

    var tabs = ['statistics', 'playback'];
    if (hasLive) {
        tabs.unshift('live');
    }

    let tab_height;
    switch (tabs[mapTabValue]) {
        case 'statistics':
            tab_height = 250;
            break;
        case 'live':
            tab_height = 35;
            break;
        case 'playback':
            tab_height = 200;
            break;
    }

    let descriptions = [];

    if (all_data_local && all_data_local.descriptions && Object.values(all_data_local.descriptions).length) {
        descriptions = all_data_local.descriptions;
    }

    try {
        var graph_data = JSON.parse(JSON.stringify(crowdCounting.data.graph))
    }
    catch (e) {
        graph_data = [];
    }

    const dashboard = useMemo(
        () => {

            if(!crowdCounting.data){
                return 
            }
            return (<StationDashboard flowRows={crowdCounting.data.egress.graph} {...{
                startLimit,
                startTime,
                endTime,
                epoch,
                endLimit: endLimitWithNow,
                setEpoch: setEpochToSetValue,
                setStartTime: setStartTimeWithMod,
                setEndTime: setEndTimeWithMod
            }}

            />)
        },
        [crowdCounting.data?.egress, endTime, startTime, shownEpoch]
    );


    if (event.event.type && event.event.type == 'egress' && crowdCounting.data) {

        return dashboard;
    }
    else {
        return (
            <Grid container spacing={3} sx={{ height: "100%" }}>
                <Grid item xxs={12} xs={12} lg={8} className="mainRow">
                    <Card sx={{ height: "100%" }}>
                        <HeatMap
                            lightPreset={mapbox_settings.lightPreset}
                            hoveredDevices={hoveredDevices}
                            map_data={heatmap_data}
                            static_map_data={event.route_shapes}
                            settings={mapbox_settings}
                            padding={100}
                            user_role={selected_user?.data?.user?.user_type}
                            isLoading={crowdCounting.isFetching}
                            epoch={epoch}
                            selectedDevices={heatmap_data.camera_points.map(r => r.uuid).join(',')}
                            setHoveredDevices={setHoveredDevices}
                            isLive={false}
                            navigateToDevice={navigateToDevice}
                            event_id={event?.event?._id}
                        >

                            <SoftBox sx={{ opacity: crowdCounting.isFetching ? 0.5 : 1, transition: 'height 0.7s ease-in-out', height: tab_height }}>
                                <SoftBox sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={mapTabValue} onChange={(r, value) => { setMapTabValue(value) }} aria-label="basic tabs example">
                                        {hasLive && <Tab label="Live" icon={<Circle sx={{ color: isLive ? "red" : "" }} />} {...a11yProps(tabs.indexOf('live'), 'map')} />}
                                        <Tab label="Statistics" icon={<ShowChart />} {...a11yProps(tabs.indexOf('statistics'), 'map')} />
                                        <Tab label="Playback" icon={<PlayCircle />}{...a11yProps(tabs.indexOf('playback'), 'map')} />
                                    </Tabs>
                                </SoftBox>
                                {hasLive && <CustomTabPanel value={mapTabValue} index={tabs.indexOf('live')} id_type={'map'}>
                                    {/* <LiveTab dataUpdatedAt={crowdCounting.dataUpdatedAt} /> */}
                                </CustomTabPanel>
                                }
                                <CustomTabPanel value={mapTabValue} index={tabs.indexOf('statistics')} id_type={'map'}>
                                    {chart}
                                </CustomTabPanel>
                                <CustomTabPanel value={mapTabValue} index={tabs.indexOf('playback')} id_type={'map'}>
                                    <Playback {...{ startTime, endTime, epoch, toggleIsPlaying, isPlaying }} ></Playback>
                                </CustomTabPanel>
                            </SoftBox>
                        </HeatMap>
                    </Card>
                </Grid>
                <Grid item xs={12} lg={4} className="mainRow">
                    <Card>
                        <SoftBox p={3}>
                            <Grid container>
                                <Grid item xs={12} md={6}>
                                    <SoftBox alignSelf="center">
                                        <SoftTypography variant="h3" mb={1}>{heatmap_data.camera_points.length} Sites</SoftTypography>
                                        <Chip sx={{ color: "#fff", backgroundColor: '#000', fontSize: "15px", height: "24px" }} label="Powered by Mercury AI"></Chip>
                                    </SoftBox>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <SoftBox alignSelf="center" textAlign="right">
                                        <SoftTypography variant="h1">{heatmap_data.count}</SoftTypography>
                                        <SoftTypography variant="h6">Total People</SoftTypography>
                                    </SoftBox>
                                </Grid>
                            </Grid>
                        </SoftBox>


                    </Card>




                    <Tabs value={dashTabValue} onChange={(r, value) => { setDashTabValue(value) }} aria-label="crowd dashboard">
                        <Tab label="Count" {...a11yProps(0, 'dash')} />
                        <Tab label="AI Insights" icon={<ElectricBolt />} {...a11yProps(1, 'dash')} />
                        <Tab label="Image" {...a11yProps(2, 'dash')} />

                        {/* <Tab label="Extras" icon={<PlayCircle />}{...a11yProps(2, 'dash')} /> */}
                    </Tabs>

                    <SoftBox sx={{ maxHeight: "calc(100% - 170px)", "overflow": "auto" }}>
                        <GeneralTab crowd_data={heatmap_data.camera_points} {...{ setHoveredDevices, navigateToDevice }} mode={dashTabValue} data={graph_data} />
                    </SoftBox>


                </Grid>
            </Grid >)
    }


}

MainView.propTypes = {
    device_uuids: PropTypes.array,
    startLimit: PropTypes.number,
    endLimit: PropTypes.number,
    settings: PropTypes.object,
    event: PropTypes.object
}

export default MainView;